import React from 'react';
import CybersecurityToolsShowcase from '../components/cybersecurity/CybersecurityToolsShowcase';

const Tools: React.FC = () => {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-3xl font-bold mb-2">Cybersecurity Tools Database</h1>
        <p className="text-gray-600">
          Explore our comprehensive collection of tools used by both Red Teams (offensive security) and Blue Teams (defensive security).
        </p>
      </div>
      
      <CybersecurityToolsShowcase />
    </div>
  );
};

export default Tools; 